export default function (element, data) {
    element.addEventListener("click", function (event) {
        let block = document.querySelector(".popup-form-container.form-popup");
        
        if(block){
            window.dispatchEvent(new CustomEvent('open-form-popup'));
        }
    });
};

